import { render, staticRenderFns } from "./BookingSlots.vue?vue&type=template&id=090d74b8&scoped=true"
import script from "./BookingSlots.vue?vue&type=script&lang=js"
export * from "./BookingSlots.vue?vue&type=script&lang=js"
import style0 from "./BookingSlots.vue?vue&type=style&index=0&id=090d74b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d74b8",
  null
  
)

export default component.exports